module.exports = __webpack_public_path__ + "static/media/bulb.962f7846.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/bulb.jpg
// module id = 324
// module chunks = 0